import { Skill } from "../interfaces/Skill";

export const ipSkills: Skill[] = [
	{
		id: 1,
		skillName: "Communication",
		skillDetails: [],
	},
	{
		id: 2,
		skillName: "Teamwork",
		skillDetails: [],
	},
	{
		id: 3,
		skillName: "Problem Solving",
		skillDetails: [],
	},
	{
		id: 5,
		skillName: "Organizational Skills",
		skillDetails: [],
	},
	{
		id: 4,
		skillName: "Leadership & Time Management",
		skillDetails: [],
	},
	{
		id: 6,
		skillName: "Open and Honest Discussions",
		skillDetails: [],
	},
];
